/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CreativeAssets56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M48 43c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM12 4a8 8 0 110 16 8 8 0 010-16z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M38.877 11.864l.482 1.802 7.83 2.099a4 4 0 012.829 4.899l-4.141 15.454a4.001 4.001 0 01-4.9 2.829l-12.951-3.471-12.95 3.47a4 4 0 01-4.9-2.828l-4.14-15.454a4 4 0 012.828-4.9l7.829-2.098.483-1.802a4.001 4.001 0 014.9-2.829l5.95 1.595 5.952-1.595a4 4 0 014.899 2.829z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M41 10c2.21 0 4 1.79 4 4v20c0 2.21-1.79 4-4 4H15c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4h26z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M41 10H15c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4h26c2.21 0 4-1.79 4-4V14c0-2.21-1.79-4-4-4zm6 5.81v15.573l2.864-10.69a3.975 3.975 0 00-2.613-4.81l-.196-.059L47 15.81zM38.222 8H30.41l2.969-.795A5.941 5.941 0 0138.223 8zm-15.887-.865l.287.07L25.59 8H41a6 6 0 016 6l-.002-.103v-.027c0-.044-.002-.087-.004-.13l.585.157a5.968 5.968 0 014.27 7.091l-.054.218-4.115 15.37a5.962 5.962 0 01-7.085 4.273l-.217-.054L37.413 40H18.586l-2.964.795a5.96 5.96 0 01-7.24-4.004l-.062-.215-4.115-15.37a5.968 5.968 0 014-7.247l.216-.062.585-.157A5.606 5.606 0 009 14v1.809l-.055.015a3.976 3.976 0 00-2.857 4.67l.048.199L9 31.391V34l.004.225L9 34V14a6 6 0 016-6h2.777a5.947 5.947 0 014.558-.865z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M41 10c2.21 0 4 1.79 4 4v20c0 2.21-1.79 4-4 4H15c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4h26z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M27 19a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 10.001 10.001A5 5 0 0027 20z"
            />
            <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M27 20a5 5 0 10.001 10.001A5 5 0 0027 20z" />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M32 18c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 1a3 3 0 100 6 3 3 0 000-6z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M32 19a3 3 0 100 6 3 3 0 000-6zm4.5 26h-14a.5.5 0 00-.09.992l.09.008h14a.5.5 0 00.09-.992L36.5 45z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M36.5 43a2.5 2.5 0 010 5H21.894a4.01 4.01 0 01-1.703-.38l-2.603-1.226c-.525-.247-.738-.847-.476-1.341.103-.194.27-.35.476-.447l2.603-1.225A3.995 3.995 0 0121.894 43H36.5zm0 3a.5.5 0 00.09-.992L36.5 45h-14a.5.5 0 00-.09.992l.09.008h14z"
            />
        </g>
    </AccessibleSVG>
);

export default CreativeAssets56;
